import { TransferState, inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { of } from 'rxjs';

export const exploreCountryResolver: ResolveFn<any> = (route, state) => {

  const ssrData = inject(TransferState);

  if (ssrData?.['EXPLORE_COUNTRY_DATA']) {
    return of(ssrData['EXPLORE_COUNTRY_DATA'].data);
  } 
  
  return null;
  

  }
